import {CreateVerifiedDomain, VerifiedDomainId} from "platformed-client/types";
import {invalidateQueries, q} from "../state";
import {platformedClient} from ".";

export async function list() {
  return await platformedClient.internalRequest("get", "/region/{region}/api/verified_domains", {path: {}});
}

export async function add(create: CreateVerifiedDomain) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/verified_domains", {
    path: {},
    body: create,
  });
  await invalidateQueries([q.verifiedDomains.filter()]);
  return res;
}

export async function verify(verifiedDomainId: VerifiedDomainId) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/verified_domains/{verified_domain_id}/verify",
    {path: {verified_domain_id: verifiedDomainId}},
  );
  await invalidateQueries([q.verifiedDomains.filter()]);
  return res;
}

export async function updateEnableSelfEnrollment(verifiedDomainId: VerifiedDomainId, enabled: boolean) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/verified_domains/{verified_domain_id}/enable_self_enrollment",
    {path: {verified_domain_id: verifiedDomainId}, body: enabled},
  );
  await invalidateQueries([q.verifiedDomains.filter()]);
  return res;
}

export async function remove(verifiedDomainId: VerifiedDomainId) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/verified_domains/{verified_domain_id}",
    {path: {verified_domain_id: verifiedDomainId}},
  );
  await invalidateQueries([q.verifiedDomains.filter()]);
  return res;
}
